module.exports = __webpack_public_path__ + "img/9788957981481.1c756cb6.jpg";